import React from 'react';
import classNames from 'classnames/bind';
import styles from './SocialShare.module.scss';
import { Row, Form } from 'antd';
import {
    FacebookShareButton,
    FacebookMessengerShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    TumblrShareButton,
    LineShareButton,
    EmailShareButton,
} from 'react-share';
import {
    FacebookIcon,
    FacebookMessengerIcon,
    LineIcon,
    LinkedinIcon,
    TelegramIcon,
    TwitterIcon,
    TumblrIcon,
    EmailIcon,
} from 'react-share';

const cx = classNames.bind(styles);

const SocialShare = ({ userInfo }) => {
    return (
        <Form>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    My QR
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    <FacebookShareButton url={userInfo?.deep_link_share} className={cx('item_social')}>
                        <span className="share-icon">
                            <FacebookIcon size={50} round />
                        </span>
                    </FacebookShareButton>

                    <FacebookMessengerShareButton url={userInfo?.deep_link_share} className={cx('item_social')}>
                        <span className="share-icon">
                            <FacebookMessengerIcon size={50} round />
                        </span>
                    </FacebookMessengerShareButton>

                    <TelegramShareButton url={userInfo?.deep_link_share} className={cx('item_social')}>
                        <span className="share-icon">
                            <TelegramIcon size={50} round />
                        </span>
                    </TelegramShareButton>

                    <TwitterShareButton url={userInfo?.deep_link_share} className={cx('item_social')}>
                        <span className="share-icon">
                            <TwitterIcon size={50} round />
                        </span>
                    </TwitterShareButton>

                    <LineShareButton url={userInfo?.deep_link_share} className={cx('item_social')}>
                        <span className="share-icon">
                            <LineIcon size={50} round />
                        </span>
                    </LineShareButton>

                    <LinkedinShareButton url={userInfo?.deep_link_share} className={cx('item_social')}>
                        <span className="share-icon">
                            <LinkedinIcon size={50} round />
                        </span>
                    </LinkedinShareButton>

                    <TumblrShareButton url={userInfo?.deep_link_share} className={cx('item_social')}>
                        <span className="share-icon">
                            <TumblrIcon size={50} round />
                        </span>
                    </TumblrShareButton>
                    <EmailShareButton url={userInfo?.deep_link_share} className={cx('item_social')}>
                        <span className="share-icon">
                            <EmailIcon size={50} round />
                        </span>
                    </EmailShareButton>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default SocialShare;
